/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowFitnessRetreatTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowFitnessRetreat,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Get Fit Together!",
    "Fitness Retreat Awaits!",
    "Embrace a Healthy Lifestyle!",
  ],
  title: "Fitness Retreat",
  description: "Organize a fun fitness retreat.",
  longDescription:
    "Gather your friends for an exciting fitness retreat! Choose a date, decide on activities, and plan meals!",
  emoji: "🏋",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Travel,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Fitness Retreat",
          emoji: "🏋",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the fitness retreat?",
          emoji: "📅",
          completeAction: {
            question: "Decide on activities to include?",
            description:
              "What activities should we focus on during the retreat?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What activities should we consider?",
                emoji: "🏃",
                completeAction: {
                  question: "Decide on meals for the retreat?",
                  description: "What meals should we plan for the retreat?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What meals should we bring?",
                      emoji: "🥗",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Embrace Fitness!",
    outroDescription: "Your fitness retreat plans are set! Enjoy the journey!",
  },
};
